import React from 'react';
import { MyWishlistList } from '../system-modules/favorites/components';

const MyWishlistPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <MyWishlistList />
    </div>
  );
};

export default MyWishlistPage;
